export default function About() {
  const teamMembers = [
    { initials: 'MK', color: 'bg-teal-400' },
    { initials: 'SL', color: 'bg-orange-400' },
    { initials: 'DJ', color: 'bg-purple-400' },
    { initials: 'AR', color: 'bg-pink-400' }
  ];

  return (
    <section id="about" className="py-32 bg-gradient-to-br from-amber-50 to-yellow-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-16">
          <p className="text-sm text-gray-600 mb-8">/ About Us</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div></div>
          <div>
            <p className="text-4xl font-light text-gray-900 leading-relaxed" style={{ lineHeight: '1.6' }}>
              NOLIOT d. o. o. is a team of experts developing modern applications for the iOS platform. Our products, such as <strong className="font-semibold">VPN</strong> and <strong className="font-semibold">Cleaner</strong>, are designed to enhance user experience and improve the security of mobile devices. We focus on creating innovative solutions that prioritize privacy, performance, and seamless functionality for iOS users worldwide.
            </p>
          </div>
        </div>

        <div className="mt-24 flex items-center gap-8">
          <div>
            <p className="text-xs text-gray-500 mb-6">• Our Team</p>
            <div className="flex items-center gap-3">
              {teamMembers.map((member, index) => (
                <div
                  key={index}
                  className={`w-14 h-14 rounded-full ${member.color} flex items-center justify-center border-2 border-white/30 shadow-lg`}
                >
                  <span className="text-white text-base font-medium">{member.initials}</span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <p className="text-base text-gray-800 font-light">Dedicated iOS specialists</p>
          </div>
        </div>
      </div>
    </section>
  );
}
